
export class RuleHumanExpression {
  humanExpression: string;
}
